//dynamic image
const images = require.context(`/public/assets/images`, true);
// const API_BASE = "http://localhost:8000/";
const API_BASE = "https://codegen-hris-api.site/";

export const dynamicImage = (image: string | undefined) => {
  return images(`./${image}`);
};

//dynamic Number
export const dynamicNumber = (totalLength: number) => {
  return Array.from({ length: totalLength }, (_, index) => index + 1);
};

//dynamic API image
export const dynamicAPIImage = (image?: string) => {
  return `${API_BASE}assets/images/${image}`;
};

//dynamic API image
export const downloadAPIAttachments = (attachment?: string) => {
  return `${API_BASE}api/applicant-attachments/download/${attachment}`;
};
